// src/modules/app-views/invoices/pages/Init/components/tableColumns/items/itemNcmColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Typography } from 'antd';
import { resolveItemFontSize } from './index';

const { Text } = Typography;

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Renders the NCM (fiscal classification) column for item subtables.
// options.className: CSS class for the cell (default: 'tax-section-start' marks start of tax columns).
// options.size: 'small' (10px, default) | 'middle' (12px)
function itemNcmColumn(options = {}) {
  const { className = 'tax-section-start', size } = options;
  const fontSize = resolveItemFontSize(size, 10);

  return {
    title: 'NCM',
    dataIndex: ['tax', 'ncm'],
    width: 80,
    align: 'center',
    className,
    sorter: (a, b) => {
      const aVal = a?.tax?.ncm || a?.ncm || '';
      const bVal = b?.tax?.ncm || b?.ncm || '';
      return aVal.localeCompare(bVal);
    },
    render: (_, item) => (
      <Text style={{ fontSize }} type="secondary">
        {item?.tax?.ncm || item?.ncm || '—'}
      </Text>
    ),
  };
}

export default itemNcmColumn;
